import { IPaginationFilteredResponse } from '@mg-platform/core/core-feature'

export interface IAdminGroup {
  id: string
  name: string
  isPublic: boolean
  shopsCount: number
  displayUnderlyingShops: boolean
  shops: string[]
}

export interface IAdminGroupsResponse extends IPaginationFilteredResponse {
  groups: IAdminGroup[]
}
